export default "/images/de09aaea4acbe2a8a18fae401666ecfd.avif";